import pLimit from 'p-limit';

export const listingBulkRequestLimit = pLimit(50);
